export default __webpack_public_path__ + "static/media/last_img.b595a37b.png";